import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { routeNames } from 'src/app/app-routing-names';
import { stepRouteMap } from '../constants/step-route-map';
import { MotorQuoteStateService } from '../services/motor-quote-state/motor-quote-state.service';
import { QuoteStateNavOptions } from '../models/app/quote-state-nav-options';

@Injectable({
    providedIn: 'root'
})
export class QuoteStepGuard {
    constructor(public router: Router,
        private readonly motorQuoteStateService: MotorQuoteStateService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const requiredStep = route.data['step'] as number;
        const redirect = route.data['redirect'] as string;
        const canBackNav = route.data['canBackNav'] as boolean | undefined;
        return this.isAllowedNavigate(requiredStep, redirect, canBackNav);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }

    isAllowedNavigate(requiredStep: number, redirect: string = routeNames.SELECT_PRODUCT, canBackNav: boolean = true): boolean {
        const currentStep = this.motorQuoteStateService.getCurrentStep();
        const completedStep = this.motorQuoteStateService.getCompletedStep();
        if ((!currentStep || currentStep < requiredStep) && completedStep < requiredStep) {
            const step = Object.keys(stepRouteMap).find(key => stepRouteMap[key] === redirect);
            if (step) this.motorQuoteStateService.setStepState(Number.parseInt(step))
            return false;
        }

        if ((currentStep > requiredStep) && !canBackNav) {
            this.motorQuoteStateService.setStepState(currentStep);
            return false;
        }
        if (currentStep !== requiredStep) {
            this.motorQuoteStateService.setStepState(requiredStep,  new QuoteStateNavOptions(false,false,undefined,true));

        }
        return true;
    }
}